<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">receipt_long</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Transacciones VES</h1>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario ID</mat-label>
            <input matInput formControlName="userId" placeholder="Ej: 12345" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="type">
              <mat-option value="">Todos</mat-option>
              <mat-option value="SWAP_USDT_VES">Swap USDT→VES</mat-option>
              <mat-option value="COMPRA_USDT_VES">Compra USDT (VES)</mat-option>
              <mat-option value="RETIRO_USDT_VES">Retiro USDT (VES)</mat-option>
              <mat-option value="RETIRO_VES">Retiro VES</mat-option>
              <mat-option value="REVERSO_RETIRO_VES">Reverso Retiro VES</mat-option>
              <mat-option value="ENVIO_VES_BENEFICIARIO">Envío VES Beneficiario</mat-option>
              <mat-option value="CREDITO_MANUAL">Crédito Manual</mat-option>
              <mat-option value="DEBITO_MANUAL">Débito Manual</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="status">
              <mat-option value="">Todos</mat-option>
              <mat-option value="completed">Completado</mat-option>
              <mat-option value="pending">Pendiente</mat-option>
              <mat-option value="rejected">Rechazado</mat-option>
              <mat-option value="failed">Fallido</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Fin</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando transacciones...</span>
  </div>

  <!-- Tabla -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading && transactions.length > 0">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
          Transacciones
        </h2>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-600">
            {{ (pagination.page - 1) * pagination.limit + 1 }} -
            {{ Math.min(pagination.page * pagination.limit, pagination.total) }}
            de {{ pagination.total }}
          </span>
          <select [value]="pagination.limit" (change)="onPageSizeChange($event)"
            style="border: 1px solid #d1d5db; border-radius: 6px; padding: 2px 8px; font-size: 0.75rem; background: white; cursor: pointer;">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="transactions" class="w-full">
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let tx"><span class="text-xs font-mono">{{ tx.userId }}</span></td>
        </ng-container>

        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let tx">
            <div class="text-xs font-medium">{{ tx.userName }}</div>
            <div class="text-xs text-gray-400">{{ tx.userEmail }}</div>
            <div *ngIf="tx.isCompany" class="text-xs text-blue-500 mt-0.5">
              {{ tx.companyName }} <span *ngIf="tx.companyRut">· {{ tx.companyRut }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="userIdentity">
          <th mat-header-cell *matHeaderCellDef>Documento</th>
          <td mat-cell *matCellDef="let tx">
            <div class="text-xs font-medium">{{ tx.userIdType }}</div>
            <div class="text-xs text-gray-400">{{ tx.userIdNumber }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let tx">
            <span class="text-xs font-medium">{{ getDisplayType(tx) }}</span>
            <div *ngIf="tx.usdtAmount" class="text-xs text-blue-600 font-bold mt-0.5">{{ formatUSDT(tx.usdtAmount) }}</div>
            <div *ngIf="tx.vesRate" class="text-xs text-gray-400 mt-0.5">Tasa: {{ tx.vesRate }}</div>
            <div *ngIf="tx.walletAddress" class="text-xs text-gray-400 mt-0.5 truncate" style="max-width: 120px;" [title]="tx.walletAddress">
              {{ tx.networkBinance }} · {{ tx.walletAddress }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="debitVes">
          <th mat-header-cell *matHeaderCellDef>Débito</th>
          <td mat-cell *matCellDef="let tx">
            <span class="text-xs font-bold" style="color: #dc2626;"
              [title]="isSwapBeneficiario(tx) ? ('Monto enviado a beneficiario: ' + formatVES(tx.debitVes)) : ''">
              {{ getDisplayDebit(tx) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="creditVes">
          <th mat-header-cell *matHeaderCellDef>Crédito</th>
          <td mat-cell *matCellDef="let tx">
            <span class="text-xs font-bold" style="color: #16a34a;">{{ formatVES(tx.creditVes) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="balanceVes">
          <th mat-header-cell *matHeaderCellDef>Saldo</th>
          <td mat-cell *matCellDef="let tx"><span class="text-xs font-bold">{{ formatVES(tx.balanceVes) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let tx">
            <span class="text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.color]="getStatusColor(tx.status)"
              [style.background]="getStatusColor(tx.status) + '15'">
              {{ tx.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Fecha <span class="text-[10px] text-gray-400 font-normal">(hora Caracas)</span></th>
          <td mat-cell *matCellDef="let tx"><span class="text-xs text-gray-600">{{ formatDate(tx.createdAt) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Acciones</th>
          <td mat-cell *matCellDef="let tx" class="text-center p-2">
            <div class="flex gap-1 justify-center flex-wrap">
              <button title="Copiar transacción" (click)="copyTransaction(tx)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #e9d5ff; border-radius: 6px; background: #faf5ff; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #7c3aed;">
                  {{ copiedTxId === tx.id ? 'check' : 'content_copy' }}
                </mat-icon>
              </button>
              <button title="Ver detalle" (click)="viewDetail(tx)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
              </button>
              <!-- Botones aprobar/rechazar deshabilitados temporalmente
              <button *ngIf="tx.status?.toLowerCase() === 'pending'" title="Aprobar" (click)="approveTransaction(tx)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">check_circle</mat-icon>
              </button>
              <button *ngIf="tx.status?.toLowerCase() === 'pending'" title="Rechazar" (click)="rejectTransaction(tx)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">cancel</mat-icon>
              </button>
              -->
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let tx of transactions; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="text-xs font-mono text-gray-500 shrink-0">{{ tx.userId }}</span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ tx.userName }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold" [style.color]="tx.creditVes ? '#16a34a' : '#dc2626'">
              {{ tx.creditVes ? formatVES(tx.creditVes) : getDisplayDebit(tx) }}
            </span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cliente</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ tx.userName }}</p>
              <p class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">{{ tx.userEmail }}</p>
              <p *ngIf="tx.isCompany" class="text-blue-500 mt-0.5" style="font-size: 0.65rem;">{{ tx.companyName }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Documento</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ tx.userIdType }}</p>
              <p class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">{{ tx.userIdNumber }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getDisplayType(tx) }}</p>
              <p *ngIf="tx.usdtAmount" class="text-blue-600 font-bold mt-0.5" style="font-size: 0.7rem;">{{ formatUSDT(tx.usdtAmount) }}</p>
              <p *ngIf="tx.vesRate" class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">Tasa: {{ tx.vesRate }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Estado</span>
              <p class="font-semibold mt-0.5" [style.color]="getStatusColor(tx.status)">{{ tx.status }}</p>
              <p *ngIf="tx.withdrawalStatus" class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">Retiro: {{ tx.withdrawalStatus }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Débito</span>
              <p class="font-bold mt-0.5" style="color: #dc2626;"
                [title]="isSwapBeneficiario(tx) ? ('Monto enviado a beneficiario: ' + formatVES(tx.debitVes)) : ''">
                {{ getDisplayDebit(tx) }}
              </p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Crédito</span>
              <p class="font-bold mt-0.5" style="color: #16a34a;">{{ formatVES(tx.creditVes) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Saldo</span>
              <p class="text-gray-700 font-bold mt-0.5">{{ formatVES(tx.balanceVes) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha <span class="normal-case text-gray-300">(hora Caracas)</span></span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatDate(tx.createdAt) }}</p>
            </div>
            <div *ngIf="tx.description" class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Descripción</span>
              <p class="text-gray-700 mt-0.5">{{ tx.description }}</p>
            </div>
            <div *ngIf="tx.operatorEmail" class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Operador</span>
              <p class="text-gray-400 mt-0.5">{{ tx.operatorEmail }}</p>
            </div>
            <div *ngIf="tx.walletAddress" class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Wallet Retiro</span>
              <p class="text-gray-700 mt-0.5" style="font-size: 0.7rem; word-break: break-all;">
                <span class="font-semibold">{{ tx.networkBinance }}</span> · {{ tx.walletAddress }}
              </p>
              <p *ngIf="tx.withdrawalFee" class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">Fee: {{ tx.withdrawalFee }} USDT</p>
              <p *ngIf="tx.binanceTxId" class="text-gray-400 mt-0.5" style="font-size: 0.65rem; word-break: break-all;">TxID: {{ tx.binanceTxId }}</p>
            </div>
          </div>
        </div>

        <!-- Botones de acción -->
        <div style="display: flex; gap: 8px; padding: 10px 16px; background: #f9fafb; border-top: 1px solid #f3f4f6; flex-wrap: wrap;">
          <button (click)="copyTransaction(tx); $event.stopPropagation()"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #7c3aed; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">
              {{ copiedTxId === tx.id ? 'check' : 'content_copy' }}
            </mat-icon>
            {{ copiedTxId === tx.id ? 'Copiado' : 'Copiar' }}
          </button>
          <button (click)="viewDetail(tx); $event.stopPropagation()"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #2563eb; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon>
            Detalle
          </button>
          <!-- Botones aprobar/rechazar deshabilitados temporalmente
          <button *ngIf="tx.status?.toLowerCase() === 'pending'" (click)="approveTransaction(tx); $event.stopPropagation()"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
            Aprobar
          </button>
          <button *ngIf="tx.status?.toLowerCase() === 'pending'" (click)="rejectTransaction(tx); $event.stopPropagation()"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #ef4444; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">cancel</mat-icon>
            Rechazar
          </button>
          -->
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="p-4">
      <mat-paginator
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginatorChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <!-- Sin datos -->
  <div *ngIf="!loading && transactions.length === 0"
    class="bg-white rounded-2xl shadow-md border border-gray-100 text-center py-8">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">inbox</mat-icon>
    <p class="text-lg font-medium text-gray-500 mt-2">No se encontraron transacciones</p>
    <p class="text-sm text-gray-400">Intenta ajustar los filtros de b&uacute;squeda</p>
  </div>
</div>
